import $visa from '@api/visa';
import moment from 'moment/moment';
import dayjs from "./day"
const changeOptions = obj => {
  const res = Object.keys(obj).map(v => {
    return {
      label: v,
      value: obj[v]
    }
  });
  return res;
};
export default {
  isWeekend(date) {
    const dayOfWeek = date.day();
    return dayOfWeek === 6 || dayOfWeek === 0; // 6 是星期六，0 是星期日
  },
  // 传入需要办理的日期,与节假日数组,返回最早出行日期
  getDateAfterWorkingDaysWithHolidays(businessDays, holidays) {
    let _this = this;

    let travelDate = dayjs().add(0, 'day'); // 当前日期

    let addedDays = 0;
    holidays = holidays.length ? holidays.filter((item) => {
      return item >= travelDate.format('YYYY-MM-DD');
    }) : [];

    // 循环直到找到合适的出行日期
    while (addedDays < businessDays) {
      travelDate = travelDate.add(1, 'day'); // 增加一天
      const travelDateStr = travelDate.format('YYYY-MM-DD');
      if (!_this.isWeekend(travelDate) && !holidays.includes(travelDateStr)) {
        addedDays++;
      } else {
        // 如果是周末或节假日，则不增加 addedDays
        addedDays = addedDays === businessDays ? 0 : addedDays;
      }
    }
    travelDate = travelDate.add(1, 'day');
    return travelDate.format('YYYY-MM-DD');
  },

  // 传入YYYY-MM-DD,与需要添加的日期，返回指定日期后的N个工作日的日期（排除周末）
  getDateAfterWorkingDays(date, days) {
    let dateObj = new Date(date);
    let daysToAdd = days;

    // 排除周末（周六和周日）  
    while (daysToAdd > 0) {
      if (dateObj.getDay() !== 0 && dateObj.getDay() !== 6) { // 检查是否为周六或周日  
        daysToAdd--;
      }
      dateObj.setDate(dateObj.getDate() + 1); // 将日期增加一天  
    }

    if (moment(dateObj).format('d') == 0) {
      dateObj.setDate(dateObj.getDate() + 1)
    } else if (moment(dateObj).format('d') == 6) {
      dateObj.setDate(dateObj.getDate() + 2)
    }

    return moment(dateObj).format('YYYY-MM-DD');
  },
  // 平滑滚动页面到指定位置（y轴）
  scrollTo(top = 0, scroll = true) {
    window.scrollTo({
      top,
      behavior: scroll ? "smooth" : "instant"
    });
  },
  // 设置标题
  setTitle(value) {
    document.title = `${value} - 深圳市常顺旅行社有限公司`;
  },
  // 获取当前用户的价格
  getPriceName() {
    const {
      userInfo
    } = this.$store.state;
    if (!userInfo) {
      return 'CustomerPrice';
    }
    const {
      identify
    } = userInfo;
    const names = {
      // 2: ['TradePrice', 'SmallCreditPaymen'],
      distribution: 'TradePrice', // 分销商
      staff: 'TradePrice', // 分销商
      partner: 'TradePrice', // 分销商
      vip: 'CustomerPrice', // 直客
      EVIP: 'BigCreditPayment' // 大客户
    };
    return names[identify] || 'CustomerPrice';
  },
  // 获取订单搜索参数
  getVisaOptions() {
    return new Promise(resolve => {
      const storageDataStr = localStorage.getItem('visaOptions');
      if (!!storageDataStr) {
        resolve(JSON.parse(storageDataStr));
        return;
      }
      $visa.getSearchData().then(data => {
        const {
          order_client_status,
          order_isPaid,
          order_refund_status,
          order_status,
          visaForm,
          visaKind
        } = data;
        let res = {
          visaForm,
          visaKind
        };
        res.clientStatus = changeOptions(order_client_status);
        res.isPaid = changeOptions(order_isPaid);
        res.refundStatus = changeOptions(order_refund_status);
        res.orderStatus = changeOptions(order_status);
        localStorage.setItem("visaOptions", JSON.stringify(res));
        resolve(res);
        // 转换数据
      })
    })

  },
  // 获取用户信息
  getUserInfo() {
    const store = this.$store.state.userInfo;
    if (store !== null) {
      return store;
    }
    const storage = JSON.parse(localStorage.getItem("userInfo") || null);
    if (storage !== null) {
      return storage;
    }
    return null;
  },
  // 更新userInfo, 支持单个参数
  updateUserInfo(user) {
    if (typeof user !== "object") {
      console.warn("[Update UserInfo Error] #参数有误！");
      return false;
    }
    const {
      userInfo: old
    } = this.$store.state;
    const userInfo = {
      ...old,
      ...user
    };
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    this.$store.commit('setUserInfo', userInfo);
  },
  // 清除用户信息
  clearUserInfo() {
    localStorage.removeItem('userInfo');
    this.$store.commit("setUserInfo", null);
  },
  // 倒计时
  startCountdown(attr, second = 60) {
    let codeTime = second; // 倒计时秒数
    this[attr] = codeTime;
    let tem = setInterval(() => {
      codeTime -= 1;
      if (codeTime === 0) {
        this[attr] = null;
        clearInterval(tem);
        return;
      }
      this[attr] = codeTime;
    }, 1000);
  },
  // 将数字转为 正常显示的价格
  ConversionPrice(price) {
    price = price ? Math.abs(price) : 0;
    return price ? (Number(price) / 100).toFixed(2) : 0;
  },
  // 将数字转为 正常显示的价格 可能为负数
  ConversionOtherPrice(price) {
    return price ? (Number(price) / 100).toFixed(2) : 0;
  },

  // 上传数据时，将价格 X100
  ConverUploadPrice(price) {
    price = Math.abs(price);
    return price ? Number(price) * 100 : price
  }
}